import * as ko from 'knockout';
import entityBase from 'entityBase';

export class c_portal_func_access_view extends entityBase {
    disabled        : KnockoutObservable<string>;
    function_id     : KnockoutObservable<string>;
    message_id      : KnockoutObservable<string>;
    message_id_descr: KnockoutObservable<string>;
    person_id       : KnockoutObservable<string>;
    portal_type     : KnockoutObservable<string>;
    read_only       : KnockoutObservable<string>;
    sales_company   : KnockoutObservable<string>;
    sequence        : KnockoutObservable<number>;
    show_on_homepage: KnockoutObservable<string>;
    show_on_navi    : KnockoutObservable<string>;

    constructor(item: any){
        super();
        this.disabled         = ko.observable(item.disabled).extend({ maxLength: 50 });
        this.function_id      = ko.observable(item.function_id).extend({ maxLength: 50 });
        this.message_id       = ko.observable(item.message_id).extend({ maxLength: 50 });
        this.message_id_descr = ko.observable(item.message_id_descr).extend({ maxLength: 50 });
        this.person_id        = ko.observable(item.person_id).extend({ maxLength: 50 });
        this.portal_type      = ko.observable(item.portal_type).extend({ maxLength: 50 });
        this.read_only        = ko.observable(item.read_only).extend({ maxLength: 50 });
        this.sales_company    = ko.observable(item.sales_company).extend({ maxLength: 50 });
        this.sequence         = ko.observable(item.sequence);
        this.show_on_homepage = ko.observable(item.show_on_homepage).extend({ maxLength: 50 });
        this.show_on_navi     = ko.observable(item.show_on_navi).extend({ maxLength: 50 });
    }
}


